<div class="intro">
  <ng-container *ngIf="shouldEnablePreChatWelcome">
    <div
      tabindex="0"
      class="chatHistoryLink"
      *ngIf="!isHistory && !isHistoryLinkEnable"
    >
      <cigna-icon type="clock" class="clock"></cigna-icon>
      <div class="historyText">
        {{ historyLabel }}
        <button
          cignaButton="blue-link"
          class="alerts-more"
          (click)="openHistory()"
          [disabled]="isUpdatingConversation"
          attr.aria-label="{{ historyButtonText }}"
        >
          {{ historyButtonText }}
        </button>
      </div>
    </div>
  </ng-container>
  <span
    tabindex="0"
    data-omni-qa="omni-dialog-disclaimer"
    *ngIf="!shouldEnableNewChat"
  >
    {{ disclaimer }}
  </span>
</div>
